export const stateTypes = {
  LOAD_STATE: 'LOAD_STATE'
};
